<template>  
  <v-item-group >
              <v-container
                  v-for="(item, i) in systemMenuList"  :key="i"
              >
                <v-item v-slot="{ active }">
                  <v-card
                   :color="i%2 == 0 ?'#BBDEFB' : '#D5F0DB'"
                    :class="active ? 'borderme' : 'borderout'"
                    class="d-flex rounded-lg "
                    dark
                    height="120"                    
                    @click="goItem({code:item.pgmId, menu: item.ename, linkUrl: item.linkAddr, menuId:item.menuId, prtId:item.prtId}) "
                  >
                      <v-list-item class="text-left">
                        <div>
                          <v-img
                            :src="item.imgButton"
                            height="55"  width="55" contain
                          ></v-img>
                        </div>
                        <!-- <v-list-item-content>
                          <v-list-item-title class="black--text"> <span style="font-size: 15pt">  {{ item.ename }} </span></v-list-item-title>
                        </v-list-item-content> -->
                        <v-list-item-content class="pa-3">
                          <v-list-item-title class="black--text text-wrap"> 
                            <span style="font-size: 15pt; line-height: 1.4;">  {{ item.ename }} </span>
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action  >
                          <v-btn icon  ripple  >
                            <v-icon color="grey lighten-1">
                                mdi-chevron-right
                            </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                  </v-card>
                </v-item>
              </v-container>
  </v-item-group>
</template>


<script>


import { getSystemMenu } from '@/api/system/menuManage'
import { openMenu } from '@/api/system/userManage'


export default {
  name: "v20Menu",
  data: () => ({
    toggle_exclusive: 1,
    systemMenuList:[],
    dataInfo: null
  }),
  components: {
   
  },
  created() {
    // this.$store.dispatch("IsMenuName", this.msg);
    this.$emit("MenuName", {code:'main', name: 'Production'}); 
    // this.$emit("MenuName", obj.menu);
  },
  mounted() {    
    this.getSystemMenuList()
  },

  methods: {
    getSystemMenuList(){
      this.systemMenuList = []
      let param = {
        userId: this.$store.state.user.userId,
        sysCd: '20',//this.$store.state.system.sysCd,
      }
      // console.log('userId: ', this.$store.state.user.userId)
      // console.log('sysCd: ', '20')

      getSystemMenu(param).then(res => {        
        this.systemMenuList = res.list      
        // console.log('getSystemMenu: ', this.systemMenuList)
      })


    },
 
    goItem(obj) {  

      
        //-------------------Login History----------------------------
        let params = {

          menuId: obj.menuId,
          prtId: obj.prtId,
          jspNm: obj.menu + '(' + obj.code + ')',
          userId: this.$store.state.user.userId,
        } 
        
        openMenu(params).then(res => {    
            })

      //-------------------Login History----------------------------
      
      // console.log('goItem: ',obj)

      this.$emit("MenuName", {code:this.$store.state.system.sysCd, name: obj.menu}); 

      if(obj.code==''||obj.code == null){
        this.snackbar = true        
      }else{
        if (obj.linkUrl == null){
            this.$router.push("/" + obj.code).catch(e => {
            this.vToastify(this.$t('View does not exist.'), 'warn')
            // if (!isNavigationFailure(e, NavigationFailureType.redirected))
            //   Promise.reject(e);
            });
          }
        else{
          window.open(obj.linkUrl);
        }      
      }

      
    },
  }
}  

</script>

<style>
</style>